import React from "react";
import { Chart } from "react-google-charts";


interface InputValues {
    data: any
    options: any
}


export function LineChart({data, options}: InputValues) {
    return (
        <Chart
            chartType="LineChart"
            width="100%"
            height="400px"
            data={data}
            options={options}
        />
    );
}
